var _a, _VegaMemoLoader_HOST;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
export class VegaMemoLoader {
    async load() {
        const uri = __classPrivateFieldGet(_a, _a, "f", _VegaMemoLoader_HOST);
        const res = await axios.get(uri);
        if (!res || !res.data) {
            return [];
        }
        return res.data.map((dto) => {
            return {
                body: dto.content,
                hash: dto.idx.toString(),
                regDate: new Date(dto.regDate),
                userIcon: dto.userIcon,
                userName: dto.userNickname,
            };
        });
    }
}
_a = VegaMemoLoader;
_VegaMemoLoader_HOST = { value: 'https://mycast.xyz:9011/memo' };
